<vectronic-card [title]="'Viewer json'" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body>
    <div class="viewer-json">
      <ngx-json-viewer [json]="json"></ngx-json-viewer>
    </div>
  </ng-container>
</vectronic-card>
